var mapMarkerColor = '#276c44';
var mapStyles = [
	{
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#f5f5f5"
			}
		]
	},
	{
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#616161"
			}
		]
	},
	{
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"color": "#f5f5f5"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#bdbdbd"
			}
		]
	},
	{
		"featureType": "administrative.neighborhood",
		// "stylers": [
		// 	{
		// 		"visibility": "off"
		// 	}
		// ]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#eeeeee"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#757575"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#e5e5e5"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#9e9e9e"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "labels",
		// "stylers": [
		// 	{
		// 		"visibility": "off"
		// 	}
		// ]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#757575"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#dadada"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#616161"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#9e9e9e"
			}
		]
	},
	{
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#e5e5e5"
			}
		]
	},
	{
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#eeeeee"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#e7f3fc"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "labels.text",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#9e9e9e"
			}
		]
	}
];

var map;
var bounds;

function mapCreate(elementId, centerLat, centerLng) {
	var mapProps = {
		zoom:12,
		panControl:false,
		zoomControl:false,
		mapTypeControl:false,
		scaleControl:false,
		streetViewControl:false,

		overviewMapControl:false,
		rotateControl:false,
		fullscreenControl:false,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		//styles: mapStyles,
		center: new google.maps.LatLng(centerLat, centerLng)
	};
	map = new google.maps.Map(document.getElementById(elementId), mapProps);
}

function mapMarkerAdd(markerLat, markerLng, markerTitle, markerSubtitle) {
	// <svg id="map-pin-fill" xmlns="http://www.w3.org/2000/svg" width="27" height="30.971" viewBox="0 0 27 30.971">
	// 	<path id="Path_66" data-name="Path 66" d="M0,0H24V24H0Z" fill="none"/>
	// 	<path id="Path_67" data-name="Path 67" d="M23.485,22.485,15,30.971,6.515,22.485a12,12,0,1,1,16.971,0ZM15,19.333A5.333,5.333,0,1,0,9.667,14,5.333,5.333,0,0,0,15,19.333Zm0-2.667A2.667,2.667,0,1,1,17.667,14,2.667,2.667,0,0,1,15,16.667Z" fill="#002b57"/>
	// </svg>

	var icon = {
		path: "M23.485,22.485,15,30.971,6.515,22.485a12,12,0,1,1,16.971,0ZM15,19.333A5.333,5.333,0,1,0,9.667,14,5.333,5.333,0,0,0,15,19.333Zm0-2.667A2.667,2.667,0,1,1,17.667,14,2.667,2.667,0,0,1,15,16.667Z",
		fillColor: mapMarkerColor,
		fillOpacity: 1,
		anchor: new google.maps.Point(15,30),
		strokeWeight: 0,
		scale: 1
	}

	//pridame marker
	var marker = new google.maps.Marker({
		map: map,
		position: new google.maps.LatLng(markerLat, markerLng),
		icon: icon,
		title: markerTitle
	});

	// if(markerTitle) {
	// 	const contentString =
	// 		'<div class="map-info-wrapper">' +
	// 		'<div class="map-info ' + markerClass + '">' +
	// 		'<div class="map-info-title">' + markerTitle + '</div>' +
	// 		'<div class="map-info-subtitle">' + markerSubtitle + '</div>' +
	// 		'</div>' +
	// 		'</div>';
	// 	const infowindow = new InfoBox({
	// 		content: contentString,
	// 		pixelOffset: new google.maps.Size(17, -28),
	// 		closeBoxURL: ""
	// 	});
	// 	infowindow.open(map, marker);
	// }

	if(!bounds) {
		bounds = new google.maps.LatLngBounds();
	}
	bounds.extend(marker.getPosition());
}

function mapFit() {
	var center = map.getCenter();
	// console.log(center);
	map.fitBounds(bounds);
	// setTimeout(function() {
	// 	console.log(center);
	// 	map.setCenter(center);
	// }, 1000)

	google.maps.event.addListenerOnce(map,'bounds_changed', function() {
		map.setCenter(center);
		map.setZoom(map.getZoom()-1);
	});

}